<div class="margin-top-xlarge">
  <h3>Prerequisite Skills Plan</h3>
  <div class="subtitle">Extra lessons and practice for students who may need extra support with this material</div>

  <div class="placeholder">
    <h4> Recommended For </h4>
  </div>

  <div class="placeholder">
    <h4> Instruction </h4>
  </div>

  <div class="placeholder">
    <h4> Targeted Practice </h4>
  </div>
</div>
